import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import FormHelperText from '@mui/material/FormHelperText';
import DialogTitle from '@mui/material/DialogTitle';
import useCustomTranslation from 'hooks/useCustomTranslation';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';

export default function FormDialog({ formOpen, setFormOpen, type, price, prices, onConfirm, formError, formSuccess }) {
  const { t } = useCustomTranslation();
  const [newName, setNewName] = React.useState(null);
  const [newPrice, setNewPrice] = React.useState(null);

  const handleClose = () => {
    setFormOpen(false);
    setNewName(null);
    setNewPrice(null);
  };

  const handlePriceChange = (value) => {
    console.log(value);
    setNewPrice(value);
  };

  //for showing price in edit modal
  React.useEffect(() => {
    //if edit
    if (type === 'edit' && price) {
      setNewPrice(price.price);
    }
    //TODO: formopen is not checked?
  }, [formOpen]);



  return (
    <React.Fragment>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={formOpen}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            console.log(newName);
            console.log(newPrice);
            onConfirm(newPrice);

            // onConfirm(newName);
            handleClose();
          },
        }}
      >
        <DialogTitle>{t('Edit price')}</DialogTitle>
        <DialogContentText p={3}>
          <TextField
            id="price"
            name="price"
            value={newPrice ?? null}
            onChange={(event) => handlePriceChange(event.target.value)}
            type="text"
            fullWidth
            variant="standard"
            autoFocus
            required
            label={t("Select price")}
          />
          {formError && <FormHelperText color="error">{formError}</FormHelperText>}
          {formSuccess && <FormHelperText color="">{formSuccess}</FormHelperText>}
        </DialogContentText>
        <DialogActions>
          <Button onClick={handleClose}>{t('Cancel')}</Button>
          <Button type="submit">{t('Confirm')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment >
  );
}
